import { apiQuery } from '../';

export const userContactsApi = apiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      archieveContact: builder.mutation({
        transformResponse: (response) => response.data,
        query: ({ contactId }) => {
          return {
            url: `/user_contacts/${contactId}/archive`,
            method: 'delete',
          };
        },
      }),

      markAsTopTalent: builder.mutation({
        transformResponse: (response) => response.data,
        query: ({ contactId, toptalent }) => {
          return {
            url: `/user_contacts/${contactId}`,
            method: 'put',
            data: {
              user_contact: { top_talent: toptalent ? 'like' : 'default' },
            },
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const { useArchieveContactMutation, useMarkAsTopTalentMutation } =
  userContactsApi;
